import React, { useState, useEffect, Fragment } from 'react';
import { Container, Row, Col, Button, Input, Card, CardBody, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter, } from "reactstrap";
import { Link, Redirect, withRouter } from "react-router-dom";
import { uploadImage } from "../../apiHelpers/uploadApiHelper";

import { connect } from 'react-redux';


import { getUsers } from '../../store/actions';
import Select from "react-select";
//i18n
import { withNamespaces } from 'react-i18next';
import moment from "moment";
import { Tabs, Form } from 'antd';
import toastr from "toastr";
import {Table, Tbody, Td, Th, Thead, Tr} from "react-super-responsive-table";
import { Pagination, Checkbox, Tooltip } from 'antd';
import SweetAlert from "react-bootstrap-sweetalert";
import {paramPost} from "../../apiHelpers/commonApiHelper";

const { TabPane } = Tabs;


const ManageUsers = (props) => {


    useEffect(() => {
        props.getUsers({ page: current, pageSize: pageSize })
    }, []);

    const [confirm_both, setconfirm_both] = useState(false);
    const [confirm_both1, setconfirm_both1] = useState(false);
    const [success_dlg, setsuccess_dlg] = useState(false);
    const [success_dlg1, setsuccess_dlg1] = useState(false);
    const [error_dlg, seterror_dlg] = useState(false);
    const [error_dlg1, seterror_dlg1] = useState(false);
    const [dynamic_title, setdynamic_title] = useState("");
    const [dynamic_description, setdynamic_description] = useState("");



    const [current, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);

    const [delId, setDelId] = useState(undefined);
    const [disId, setDisId] = useState(undefined);
    const [disType, setDisType] = useState(undefined);

    const onShowSizeChange = (current, pageSize) => {
        props.getUsers({ page: current, pageSize: pageSize })
        setPageSize(pageSize)
        setCurrentPage(current)
    }
    const onChange = (page) => {
        props.getUsers({ page: page, pageSize: pageSize })
        setCurrentPage(page)
    }

    const users = () => {
        if(props.users) {
            return props.users.map((user, index) => {
                return (
                    <Tr key={index}>
                        <Td>{user.name}</Td>
                        <Td>{user.players.length > 0 ? user.players.length : '0'}</Td>
                        <Td>{user.campaigns.length > 0 ? user.campaigns.length : '0'}</Td>
                        <Td>{user.media.length > 0 ? user.media.length : '0'}</Td>
                        <Td>

                                {user.is_disabled === "enabled" ?
                                    <Tooltip title="Disable user">
                                        <i className="action-cursor fas fa-user-lock text-success"
                                           onClick={() => handleDisable(user.id, 1)}>
                                        </i>
                                    </Tooltip>:
                                    <Tooltip title="Enable user">
                                        <i className="action-cursor fas fa-user-lock text-warning"
                                           onClick={() => handleDisable(user.id, 0)}>
                                        </i>
                                    </Tooltip>
                                }
                            <Tooltip title="Delete User">
                                <i className="action-cursor fas fa-user-times ml-2 text-danger"
                                   onClick={() => {handleDelete(user.id)}}
                                ></i>
                            </Tooltip>
                        </Td>
                    </Tr>
                )
            })
        }
    }

    const deleteUser = () => {
        paramPost('/api/v1/admin/delete_user', {id: delId})
            .then((result) => {
                clear();
                if(result.status === 200) {
                    setsuccess_dlg(true);
                    setdynamic_title("Deleted");
                    setdynamic_description("User deleted successfully");
                } else {
                    setdynamic_title("Failed");
                    setdynamic_description("Something went wrong. Try again");
                    seterror_dlg(true);
                }
            })
            .catch((err) => {
                clear();
                setdynamic_title("Error");
                setdynamic_description("Something went wrong. Try again");
                seterror_dlg(true);
            })
    }

    const handleDisableReq = () => {
        paramPost('/api/v1/admin/disable_user', {id: disId, type: disType})
            .then(result => {
                clear();
                if(result.status === 200) {
                    setsuccess_dlg1(true);
                    setdynamic_title("Updated");
                    setdynamic_description(result.data.message);
                } else {
                    setdynamic_title("Error");
                    setdynamic_description(result.data.message);
                    seterror_dlg1(true);
                }
            })
            .catch(err => {
                console.log(err);
                toastr.error("Something went wrong. Please try again", "Error");
                clear();
            })
    }

    const handleDisable = (id, type) => {
        setconfirm_both1(true);
        setDisId(id);
        setDisType(type);
    }

    const handleDelete = (id) => {
        setconfirm_both(true);
        setDelId(id);
    }

    const clear = () => {
        setDisId(undefined);
        setDelId(undefined);
        setDisType(undefined);
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="content-parent-div">
                    <Row className="mt-3">
                        <Col sm={12} className="mt-3">
                            <Card className="card-style">
                                <CardHeader>Manage Users</CardHeader>
                                <CardBody>
                                    <div
                                        className="table-responsive mb-0"
                                        data-pattern="priority-columns"
                                    >
                                        <Table
                                            id="tech-companies-1"
                                            className="table table-striped table-bordered content-table"
                                        >
                                            <Thead>
                                                <Tr>
                                                    <Th data-priority="1">Name</Th>
                                                    <Th data-priority="1">Screens</Th>
                                                    <Th data-priority="1">Campaigns</Th>
                                                    <Th data-priority="1">Uploaded Files</Th>
                                                    <Th data-priority="1">Action</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody className="">{users()}</Tbody>
                                        </Table>
                                    </div>
                                    <Pagination className="float-right" current={current} defaultPageSize={20} onShowSizeChange={onShowSizeChange} onChange={onChange} total={props.total} />
                                </CardBody>
                            </Card>
                            {props.loading && (
                                <div className="loading-icon">
                                    <i className="fas fa-sync fa-spin"></i>
                                </div>
                            )}
                        </Col>
                    </Row>

                    {confirm_both ? (
                        <SweetAlert
                            title={"Are you sure?"}
                            warning
                            showCancel
                            confirmBtnBsStyle="success"
                            cancelBtnBsStyle="danger"
                            onConfirm={() => {
                                setconfirm_both(false);
                                deleteUser();
                            }}
                            onCancel={() => {
                                setconfirm_both(false);
                                setsuccess_dlg(false);
                                setdynamic_title("Cancelled");
                                setdynamic_description("");
                            }}
                        >
                            Delete this user?
                        </SweetAlert>
                    ) : null}

                    {success_dlg ? (
                        <SweetAlert
                            success
                            title={dynamic_title}
                            onConfirm={() => {
                                props.getUsers({ page: current, pageSize: pageSize });
                                setsuccess_dlg(false);
                            }}
                        >
                            {dynamic_description}
                        </SweetAlert>
                    ) : null}

                    {error_dlg ? (
                        <SweetAlert
                            error
                            title={dynamic_title}
                            onConfirm={() => {
                                seterror_dlg(false);
                            }}
                        >
                            {dynamic_description}
                        </SweetAlert>
                    ) : null}


                    {confirm_both1 ? (
                        <SweetAlert
                            title={"Are you sure?"}
                            warning
                            showCancel
                            confirmBtnBsStyle="success"
                            cancelBtnBsStyle="danger"
                            onConfirm={() => {
                                setconfirm_both1(false);
                                handleDisableReq();
                            }}
                            onCancel={() => {
                                setconfirm_both1(false);
                                setsuccess_dlg(false);
                                setdynamic_title("Cancelled");
                                setdynamic_description("");
                            }}
                        >
                            Disable/Enable this user?
                        </SweetAlert>
                    ) : null}

                    {success_dlg1 ? (
                        <SweetAlert
                            success
                            title={dynamic_title}
                            onConfirm={() => {
                                props.getUsers({ page: current, pageSize: pageSize });
                                setsuccess_dlg1(false);
                            }}
                        >
                            {dynamic_description}
                        </SweetAlert>
                    ) : null}

                    {error_dlg1 ? (
                        <SweetAlert
                            error
                            title={dynamic_title}
                            onConfirm={() => {
                                seterror_dlg1(false);
                            }}
                        >
                            {dynamic_description}
                        </SweetAlert>
                    ) : null}
                </Container>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    const { users, loading, total } = state.AdminReducer;
    return { users, loading, total };
}

export default withRouter(connect(mapStateToProps, { getUsers })(withNamespaces()(ManageUsers)));
